<template>
    <div>
        <b-modal
                id="export-verification-process-popup"
                ref="modal"
                title="Export Verification List"
                size="sm"
                hide-footer
                modal-class="hide-footer"
                :hide-header-close="loading"
                no-close-on-backdrop
                no-close-on-esc
                selected_users="selected_users"
        >
            <!--<p class="m-custom">-->
                <!--Would you like to download report data in Excel format or-->
                <!--graphical charts as pdf?-->
            <!--</p>-->

            <b-form
                    @submit.stop.prevent="exportReport()"
                    @reset.stop.prevent="onHidden"
            >
                <div class="row custom-model-form">
                    <div class="col-md-12">
                        <div class="export-radio-section">
                            <div class="icon-section">
                                <div class="excel-icons">
                                    <excel-icon></excel-icon>
                                </div>
                            </div>
                            <div class="export-form-section">
                                <b-form-group class="export-files">
                                    <b-form-radio-group
                                            v-model="exportType"
                                            :options="form.exportType"
                                            name="export"
                                    ></b-form-radio-group>
                                </b-form-group>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-12 action-buttons">
                    <base-button
                            :class="loading ? 'disabled' : ''"
                            btn-label="Download"
                            btn-type="submit"
                            btn-variant="primary"
                    ></base-button>
                    <base-button
                            :disabled="loading"
                            btn-label="Cancel"
                            btn-type="reset"
                            btn-variant="link"
                    ></base-button>
                </div>
            </b-form>
        </b-modal>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'

    import excelIcon from '@/components/icons/ExcelIcon.vue'
    import pdfIcon from '@/components/icons/PdfIcon.vue'
    import XLSX from 'xlsx'
    import _ from 'lodash'
    import request from '@/utils/request'
    import axios from 'axios'

    export default {
        /*
        |--------------------------------------------------------------------------
        | Component > components
        |--------------------------------------------------------------------------
        */
        components: {
            excelIcon,
        },
        /*
        |--------------------------------------------------------------------------
        | Component > props
        |--------------------------------------------------------------------------
        */
        props: {
            exportGraphId: {
                type: String,
                default: null,
            },
            fileName: {
                type: String,
                required: true,
            },
            graphIds: {
                type: Array,
                required: true,
            },
            query:{
                type: Object,
                required: false
            },
            selected_users:{
                type: Object,
                required:false
            }

        },
        /*
        |--------------------------------------------------------------------------
        | Component > data
        |--------------------------------------------------------------------------
        */
        data() {
            return {
                exportType: 'xlsx',
                form: {
                    exportType: [
                        {
                            text: 'Export All Customers',
                            value: 'exportCustomerDetailsExcel',
                        },
                    ],
                },
            }
        },

        /*
        |--------------------------------------------------------------------------
        | Component > computed
        |--------------------------------------------------------------------------
        */
        computed: {
            ...mapGetters([
                'loading',
                'hidePopup',
                'chartsHeadings',
                'dataSegmentId',
                'hasScopes',
            ]),
        },
        /*
        |--------------------------------------------------------------------------
        | Component > methods
        |--------------------------------------------------------------------------
        */
        methods: {
            async exportReport() {
                try {
                    if (this.exportType == 'exportCustomerDetailsExcel') {
                        this.$store.commit('setLoading', true)
                        this.exportCustomerDetails()
                    }
                    else
                    {
                        this.$store.commit('setError', 'Please select an option first')
                    }
                } catch (error) {
                    this.$store.commit('setLoading', false)
                    this.$store.commit('setError', error)
                }
            }, //end of exportReport()

            exportCustomerDetails(){
                let query=this.query
                let users=this.selected_users
                axios({
                    method: 'post',
                    url: `${process.env.VUE_APP_API_URL}customers/export-verification-list`,
                    params: {'query':query,'selected_users':users}
                    // responseType: 'blob',
                })
                    .then((response) => {
                        this.$store.commit('setLoading', false)
                        this.onHidden()
                        this.$emit('emptyCheckBoxes',true)
                        this.$toasted.show('Export request sent, you will see your download shortly',{
                            type: 'success',
                            duration: 5000,
                            keepOnHover:true
                        })
                    })
                    .catch(() => console.log('error occurred'))
            },


            /**
             * Handle when the modal is closed
             *
             * @return {void}
             */
            onHidden() {
                this.$refs.modal.hide()
            }, // End of onHidden() method
            /**
             * Export Activity Timeline
             *
             * @return {void}
             */

        },
    }
</script>
